import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import LocationSvg from "../../../Common/svg/location";
import { useMutation, useQuery } from "react-query";
import { getCities } from "../../../../MyApi/admin/cities";
import { getCountries } from "../../../../MyApi/admin/countries/countries";
import {
  getZones,
  postZones,
  showZones,
  updateZones,
} from "../../../../MyApi/zones";
import { getGovernorates } from "../../../../MyApi/admin/governorates";
import { toast } from "react-toastify";
import i18next from "i18next";
import LoadingSpinner from "../../../UI/spinner";
import LangSelectModal from "../../../UI/langselectmodal";

const ZonesModal = ({
  show,
  toggle,
  openModal,
  locations = [],
  onClose,
  refetch,
  modalMode,
  modalId,
  setLocations,
}) => {
  const [zoneData, setZoneData] = useState({
    name: "",
    country_id: null,
    governorate_id: null,
    city_id: null,
    area: locations,
    is_active: 1,
  });
  const [selectedCodeLang, setSelectedLangCode] = useState("ar");
  const lang = i18next.language;
  useEffect(() => {
    setZoneData((prev) => ({ ...prev, area: locations }));
  }, [locations]);
  useEffect(() => {
    setSelectedLangCode(lang);
  }, []);

  const mutation = useMutation({
    mutationKey: ["postZone"],
    mutationFn: (postData) => postZones(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      onClose("zone", "add");
      refetch();
    },
  });
  const mutationUpdate = useMutation({
    mutationKey: ["updateZone"],
    mutationFn: (postData) => updateZones(postData, modalId),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      onClose("zone", "edit");
      setLocations([]);
      refetch();
    },
  });
  console.log("modalId", modalId);

  //show
  const { data: zoneShowData, isLoading } = useQuery(
    ["showZones", modalId, selectedCodeLang],
    () => showZones(modalId, selectedCodeLang),
    {
      enabled: !!modalId && modalMode === "edit",
    },
  );

  const citiesQuery = useQuery(["getCities", zoneData.governorate_id], () =>
    getCities(lang, "", zoneData.governorate_id),
  );
  const countriesQuery = useQuery("getCountries", () => getCountries(lang));
  const governoratesQuery = useQuery(
    ["getGovernorates", zoneData.country_id],
    () => getGovernorates(zoneData.country_id, lang),
  );

  const cities = citiesQuery?.data?.data?.cities || [];
  const countries = countriesQuery?.data?.data?.countries || [];
  const governorates = governoratesQuery?.data?.data?.governorates || [];
  const zones = zoneShowData?.data?.zone || {};

  useEffect(() => {
    if (zones && modalMode === "edit") {
      setZoneData((prev) => ({
        ...prev,
        name: zones?.name,
        country_id: zones?.country?.id,
        country: zones?.city?.governorate?.country,
        governorate: zones?.city?.governorate,
        city: zones?.city,
        governorate_id: zones?.city?.governorate?.id,
        city_id: zones?.city?.id,
        area: zones?.area,
        is_active: 1,
      }));

      setLocations(zones.area);
    }
  }, [zones]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setZoneData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, option) => {
    setZoneData((prev) => {
      if (name === "country")
        return { ...prev, country: option, country_id: option?.id || null };
      if (name === "governorate")
        return {
          ...prev,
          governorate: option,
          governorate_id: option?.id || null,
        };
      if (name === "city")
        return { ...prev, city: option, city_id: option?.id || null };
      return prev;
    });
  };
  const handleSelectedLangChange = (e) => {
    setSelectedLangCode(e.target.value);
  };

  const handleSubmit = () => {
    console.log("Form Data:", zoneData);
    if (modalMode === "edit") {
      const updateZoneData = {
        ...zoneData,
        _method: "PUT",
        lang: selectedCodeLang,
      };
      mutationUpdate.mutate(updateZoneData);
    } else {
      mutation.mutate(zoneData);
    }
  };
  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Modal isOpen={show} toggle={toggle}>
      <ModalHeader toggle={toggle} className="border-0" closeButton>
        {modalMode === "edit" ? "تعديل المنطقة" : "إضافة المنطقة"}
      </ModalHeader>

      <ModalBody>
        <div className="row add">
          {modalMode === "edit" && (
            <div className="col-12">
              <LangSelectModal
                selectedLangCode={selectedCodeLang}
                handleChange={handleSelectedLangChange}
              />
            </div>
          )}
          {/* اسم المنطقة */}
          <div className="col-12 mb-3">
            <label htmlFor="zoneName" className="form-label">
              اسم المنطقة
            </label>
            <input
              id="zoneName"
              name="name"
              type="text"
              className="form-control"
              placeholder="أدخل اسم المنطقة"
              value={zoneData.name}
              onChange={handleChange}
            />
          </div>

          {/* الدولة */}
          <div className="col-12 mb-3">
            <label className="form-label">الدولة</label>
            <Select
              options={countries}
              value={zoneData.country}
              onChange={(option) => handleSelectChange("country", option)}
              getOptionLabel={(opt) => opt.name}
              getOptionValue={(opt) => opt.id}
            />
          </div>

          {/* المحافظة */}
          <div className="col-12 mb-3">
            <label className="form-label">المحافظة</label>
            <Select
              options={governorates}
              value={zoneData.governorate}
              onChange={(option) => handleSelectChange("governorate", option)}
              getOptionLabel={(opt) => opt.name}
              getOptionValue={(opt) => opt.id}
            />
          </div>

          {/* المدينة */}
          <div className="col-12 mb-3">
            <label className="form-label">المدينة</label>
            <Select
              options={cities}
              name="city_id"
              value={zoneData.city}
              onChange={(option) => handleSelectChange("city", option)}
              getOptionLabel={(opt) => opt.name}
              getOptionValue={(opt) => opt.id}
            />
          </div>

          {/* اختيار الموقع من الخريطة */}
          <div
            className="choose-location mt-3 m-auto"
            onClick={() => openModal("map", modalMode, modalId)}
            style={{ cursor: "pointer" }}
          >
            <LocationSvg />
            {locations?.length > 0 ? (
              <p className="mt-3"> تم اختيار موقع</p>
            ) : (
              <p className="mt-3">اختر الموقع من الخريطة</p>
            )}
          </div>
        </div>
      </ModalBody>

      <ModalFooter className="justify-content-start border-0">
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={mutationUpdate.isLoading || mutation.isLoading}
        >
          {mutationUpdate.isLoading || mutation.isLoading ? (
            <Spinner />
          ) : modalMode === "edit" ? (
            "تعديل المنطقة"
          ) : (
            "إضافة منطقة"
          )}
        </button>
        <button
          className="btn btn-white"
          onClick={() => onClose("zone", modalMode)}
        >
          إلغاء
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ZonesModal;
